// Service catalogue — used by /services and /services/:slug

export const SERVICES = [
  {
    slug: "puppy-school",
    icon: "GraduationCap",
    title: "Puppy School",
    short_title: "Puppy School",
    price: "$149 AUD",
    duration: "4 weeks · 45 min/class",
    eyebrow: "Group classes",
    headline: "The foundation for a well-behaved adult dog.",
    desc: "Small friendly group classes that focus on real-life skills, not just tricks. The 4-week foundation puppy school taught the way the team teaches it in person — fear-free, evidence-based, calm, and personalised.",
    bullets: [
      "Maximum 6 puppies per class for personalised attention",
      "Loose-leash walking, recall, focus around distractions",
      "Fear-free, evidence-based methods",
      "Session summary reports + homework after each class",
      "Free treat pouch + online video library access",
      "Email help between classes",
    ],
    eligibility: "Puppies must be aged 8 to 14 weeks at the start of the course and have had at least one vaccination.",
    locations: [
      "Mudjimba Community Hall (Sat AM / Mon PM)",
      "Kawana Scouts Hall (Mon AM)",
      "Eudlo Hall (Wed AM)",
    ],
    color: "#f38838",
    image: "https://images.unsplash.com/photo-1601758125946-6ec2ef64daf8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta_primary: { label: "See All Intakes", href: "/courses/in-person" },
    cta_secondary: { label: "Ask the team", href: "/contact" },
    related: ["teenage-puppy", "scent-detection", "private-consults"],
    faq: [
      { q: "What if my puppy is too old?", a: "If your puppy is 14+ weeks, Teenage Puppy School is the right fit." },
      { q: "Do I need to bring food?", a: "Bring a hungry puppy and lots of small, soft, high-value treats." },
      { q: "What if we miss a class?", a: "Reach out and we'll send you the homework + a make-up if available." },
    ],
  },
  {
    slug: "activities-class",
    icon: "PawPrint",
    title: "Activities Class",
    short_title: "Activities Class",
    price: "$50 AUD",
    duration: "1:1 · 30 minutes",
    eyebrow: "1:1 with the team",
    headline: "Brain games, scent work and agility lite — all in one session.",
    desc: "A private 1:1 30-minute activities class designed to channel your dog's energy and brain into something brilliant. We blend brain games, scent work and a touch of agility lite to keep things fresh — perfect as a one-off enrichment booster or a regular weekly outing.",
    bullets: [
      "Private 1:1 session with the team — fully focused on your dog",
      "Mix of brain games, scent work and agility lite",
      "Builds focus, confidence and meaningful mental enrichment",
      "Suits any breed once basic engagement is in place",
      "$50 per 30-minute session — book one-off or in blocks",
    ],
    eligibility: "Any age once your dog is reliably engaging and food/toy motivated. Reactive dogs welcome — let the team know in advance.",
    locations: [
      "Mudjimba Community Hall (all activities)",
      "Kawana Scouts Hall (all activities)",
      "Eudlo Hall (brain games & scent work — agility not offered at Eudlo)",
    ],
    color: "#E2B054",
    image: "https://images.unsplash.com/photo-1601758125946-6ec2ef64daf8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta_primary: { label: "Email the team to book", href: "mailto:support@puppl.app?subject=Activities%20Class%20booking" },
    cta_secondary: { label: "See locations", href: "/service-areas" },
    related: ["scent-detection", "private-consults", "puppy-school"],
    faq: [
      { q: "Is agility offered at every hall?", a: "Agility lite is available at Mudjimba and Kawana. Eudlo Hall sessions focus on brain games and scent work only." },
      { q: "Can I book a series?", a: "Yes — bulk-book in blocks of 4 or 8 by emailing the team directly." },
      { q: "Is this suitable for puppies?", a: "Yes, once your puppy has the basics of engagement and recall — usually post-Puppy School." },
    ],
  },
  {
    slug: "teenage-puppy",
    icon: "GraduationCap",
    title: "Teenage Puppy School",
    short_title: "Teenage Puppy",
    price: "From $149 AUD",
    duration: "4 discounted private sessions",
    eyebrow: "1:1 with the team",
    headline: "Catch-up plan for puppies who've aged out of group classes.",
    desc: "Four discounted private sessions to give your dog the same skills they'd learn in Puppy School and get them started off on the right paw — taught 1:1 with the team, scheduled to suit you.",
    bullets: [
      "Four 1:1 private sessions at a discounted bundle rate",
      "Same foundation curriculum as group Puppy School — recall, focus, settling, manners",
      "Real-world distraction work",
      "Fear-free, evidence-based methods",
    ],
    eligibility: "Puppies 14 weeks and over, with two or more vaccinations.",
    locations: ["In your home or at a Sunshine Coast public location"],
    color: "#1b4a76",
    image: "https://customer-assets.emergentagent.com/job_bark-academy-9/artifacts/29rqen3t_pct%20puppy%20school.png",
    cta_primary: { label: "Book a bundle with the team", href: "/contact" },
    cta_secondary: { label: "Ask the team", href: "/contact" },
    related: ["puppy-school", "private-consults", "scent-detection"],
    faq: [
      { q: "Is this for reactive teenagers?", a: "If your dog is reactive or anxious, we'll guide you toward private training first." },
    ],
  },
  {
    slug: "private-consults",
    icon: "House",
    title: "Private Puppy Consults",
    short_title: "Private Consults",
    price: "Custom quote",
    duration: "1:1 sessions",
    eyebrow: "One-to-one",
    headline: "Tailored to your puppy, your home, your goals.",
    desc: "One-on-one sessions in your home or at a public place. Tailored entirely to you and your puppy, with training plans and goals to raise the adult dog you want.",
    bullets: [
      "Sessions tailored to your puppy's personality and your goals",
      "Personal training plans + measurable milestones",
      "Skills and knowledge to keep training as your puppy grows",
      "Ideal for first-time puppy parents or specific issues",
    ],
    eligibility: "Open to all ages. Reactivity, anxiety and behaviour concerns reviewed personally by the team.",
    color: "#E2B054",
    image: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta_primary: { label: "Email the team", href: "mailto:support@puppl.app?subject=Private%20consult%20enquiry" },
    cta_secondary: { label: "Live chat", href: "#chat" },
    related: ["walk-and-trains", "home-check-ins", "puppy-school"],
    faq: [
      { q: "What do I include in my email?", a: "Your suburb, your puppy's age, and a brief description of what you'd like help with." },
    ],
  },
  {
    slug: "walk-and-trains",
    icon: "PersonSimpleWalk",
    title: "Puppy Walk & Trains",
    short_title: "Walk & Trains",
    price: "Per session",
    duration: "Pick-up & training",
    eyebrow: "Done-for-you",
    headline: "We take your puppy for a play & train.",
    desc: "the team picks up your puppy for a play and train session — safe socialisation, confidence building and habit-forming, while you focus on work or family.",
    bullets: [
      "One-on-one confidence building sessions",
      "Safe socialisation based on vaccination status",
      "Loose-leash walking & recall habits built in",
      "Trained by puppy specialist the Puppl team",
    ],
    eligibility: "Sunshine Coast area only.",
    color: "#f38838",
    image: "https://images.unsplash.com/photo-1444212477490-ca407925329e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta_primary: { label: "Email to book", href: "mailto:support@puppl.app?subject=Walk%20%26%20Train%20booking" },
    cta_secondary: { label: "See pricing", href: "/contact" },
    related: ["home-check-ins", "private-consults"],
    faq: [],
  },
  {
    slug: "home-check-ins",
    icon: "Coffee",
    title: "Puppy Home Check-Ins",
    short_title: "Home Check-Ins",
    price: "30-min sessions",
    duration: "While you're out",
    eyebrow: "Done-for-you",
    headline: "Drop-in care to break up your puppy's day.",
    desc: "We drop in to check on your puppy while you're at work. Exercise, play, toileting, food and water — your pup's day, properly broken up.",
    bullets: [
      "30-minute drop-in sessions",
      "Safe exercise + play to break up the day",
      "Toilet break + feed/water as needed",
      "Peace of mind while you're at work",
    ],
    eligibility: "Sunshine Coast suburbs.",
    color: "#1b4a76",
    image: "https://images.unsplash.com/photo-1583511666372-62fc211f8377?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta_primary: { label: "Email to book", href: "mailto:support@puppl.app?subject=Home%20check-in%20booking" },
    cta_secondary: { label: "See locations", href: "/service-areas" },
    related: ["walk-and-trains", "private-consults"],
    faq: [],
  },
  {
    slug: "therapy-dog",
    icon: "HeartStraight",
    title: "Therapy Dog Training",
    short_title: "Therapy Dog",
    price: "By application",
    duration: "Program-based",
    eyebrow: "Program",
    headline: "Wishlist Therapy Dog Program assessor.",
    desc: "the team is the assessor for the Wishlist Therapy Dog Program at Sunshine Coast University Hospital — preparing well-suited dogs for therapy work.",
    bullets: [
      "Wishlist Therapy Dog Program at SCUH",
      "Initial self-assessment to start",
      "Trained for therapy work in hospitals & care settings",
    ],
    eligibility: "Referral via Wishlist required. Email therapydogs@wishlist.org to express interest.",
    color: "#E2B054",
    image: "https://customer-assets.emergentagent.com/job_bark-academy-9/artifacts/l5uc7lyc_Chralotte%20bryan%20therapy%20dogs.jpg",
    cta_primary: { label: "Start self-assessment", href: "https://link.digiwoof.com/widget/form/2o5NaUVzcOtu9Q4z5riP" },
    cta_secondary: { label: "Email Wishlist", href: "mailto:therapydogs@wishlist.org" },
    related: ["private-consults"],
    faq: [
      { q: "What dogs are suited?", a: "Calm, confident, social dogs who genuinely enjoy meeting strangers and being touched." },
    ],
  },
  {
    slug: "scent-detection",
    icon: "PawPrint",
    title: "Scent Detection Classes",
    short_title: "Scent Detection",
    price: "From $199 AUD",
    duration: "Multi-week",
    eyebrow: "Enrichment",
    headline: "Channel that nose into structured scent work.",
    desc: "Scent Detection classes teach dogs how to search for and indicate a non-food odour using structured scent work exercises. A great way to build focus and provide meaningful mental enrichment.",
    bullets: [
      "Non-food odour search + indication",
      "Builds focus and confidence",
      "Meaningful mental enrichment for any breed",
      "Small classes, lots of repetition",
    ],
    eligibility: "Open to any age once basic engagement is in place.",
    locations: ["Eudlo Hall"],
    color: "#f38838",
    image: "https://images.unsplash.com/photo-1551717743-49959800b1f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta_primary: { label: "See upcoming dates", href: "/courses/in-person" },
    cta_secondary: { label: "Ask the team", href: "/contact" },
    related: ["puppy-school", "teenage-puppy", "private-consults"],
    faq: [],
  },
];

export const SERVICE_BY_SLUG = Object.fromEntries(SERVICES.map((s) => [s.slug, s]));
